import React from 'react';
import { Check, X } from 'lucide-react';
import { Button } from './ui/button';
import { comparisonData } from '../data/mock';
import CTAButtons from './CTAButtons';

const Comparison = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <div className="inline-block mb-4 px-4 py-2 bg-blue-100 text-blue-800 rounded-full text-xl font-semibold">
            Your Advantage, Our Priority
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why We're the Ultimate Choice for Your Trademark Needs
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            With Global Trademark USA, you get expert guidance and tailored support every step of the way. Our commitment to transparency and customer care ensures a seamless trademark registration experience.
          </p>
        </div>

        <div className="max-w-5xl mx-auto overflow-x-auto">
          <table className="w-full bg-white rounded-2xl shadow-xl overflow-hidden">
            <thead>
              <tr className="bg-gradient-to-r from-emerald-600 to-blue-600 text-white">
                <th className="py-6 px-6 text-left text-lg font-bold">What Sets Us Apart</th>
                <th className="py-6 px-6 text-center text-lg font-bold">Global Trademark USA</th>
                <th className="py-6 px-6 text-center text-lg font-bold">Online Competitors</th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, index) => (
                <tr key={index} className={`border-b border-gray-100 hover:bg-emerald-50 transition-colors ${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}`}>
                  <td className="py-5 px-6 text-gray-800 font-medium">{row.feature}</td>
                  <td className="py-5 px-6 text-center">
                    {row.us ? (
                      <div className="inline-flex items-center justify-center w-8 h-8 bg-emerald-100 rounded-full">
                        <Check className="w-5 h-5 text-emerald-600" />
                      </div>
                    ) : (
                      <div className="inline-flex items-center justify-center w-8 h-8 bg-red-100 rounded-full">
                        <X className="w-5 h-5 text-red-600" />
                      </div>
                    )}
                  </td>
                  <td className="py-5 px-6 text-center">
                    {row.competitors ? (
                      <div className="inline-flex items-center justify-center w-8 h-8 bg-emerald-100 rounded-full">
                        <Check className="w-5 h-5 text-emerald-600" />
                      </div>
                    ) : (
                      <div className="inline-flex items-center justify-center w-8 h-8 bg-red-100 rounded-full">
                        <X className="w-5 h-5 text-red-600" />
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="text-center mt-12">
          <CTAButtons className="justify-center" />
        </div>
      </div>
    </section>
  );
};

export default Comparison;